import { BaseService } from './../../shared-service/base.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'nomore-data',
  templateUrl: './nomore-data.component.html',
  styleUrls: ['./nomore-data.component.css']
})
export class NomoreDataComponent implements OnInit {

  @Input('id') id: string = '';
  //@Input('msgType') msgType: string = 'rbkey_NoItmToDsply';  
  @Input('msgType') msgType: any = '1';  

  message: string='No item to display.';

  constructor(public bs: BaseService) { }

  ngOnInit() {
    this.id = this.id != undefined ? this.id : '';
    // this.msgType = this.msgType != undefined ? this.msgType : 'rbkey_NoItmToDsply';  
    // this.message = this.bs.getResource(this.msgType);  

    if(this.msgType == '1')
    {
      this.message = this.bs.getResource('rbkey_NoItmToDsply');
    }
    else  if(this.msgType == '2')
    {
      this.message = this.bs.getResource('rbkey_AvlablChnnlNoDtFndLBL');
    }
    else  if(this.msgType == '3')
    {
      this.message = this.bs.getResource('rbkey_No_Dscrptn_Avlbl');
    }
    else{
      this.message = this.bs.getResource('rbkey_NoItmToDsply');;
    }

  }

}
